import React from 'react';
import { createContext, useState } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom'
import './App.css';
import About from './components/About/About/About';
import Articles from './components/Articles/Articles';
import Career from './components/Career/Career';
import Home from './components/Home/Home/Home';
import ProductDetail from './components/ProductDetail/ProductDetail';
import Products from './components/Products/Products/Products';
import NotFound from './components/Shared/NotFound/NotFound';
import { LanguageContext } from './Contexts/LanguageContext';

// export const LanguageContext = createContext()

function App() {
  const [isBangla, setIsBangla] = useState(false)
  return (
    <LanguageContext.Provider value={[isBangla, setIsBangla]}>
      <Router>
        <Switch>
          <Route exact path='/'>
            <Home />
          </Route>
          <Route path='/products'>
            <Products />
          </Route>
          <Route path='/product-detail/:id'>
            <ProductDetail />
          </Route>
          <Route path='/about'>
            <About />
          </Route>
          <Route path='/career'>
            <Career />
          </Route>
          <Route path='/articles'>
            <Articles />
          </Route>
          <Route exact path='*'>
            <NotFound />
          </Route>
        </Switch>
      </Router>
    </LanguageContext.Provider>
  );
}

export default App;
